var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQr = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14164_107620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.25 0H0.5V28.75H29.25V0ZM23.5 23H6.25V5.75H23.5V23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 11.5H12V17.25H17.75V11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.75 0V28.75H92.5V0H63.75ZM86.75 23H69.5V5.75H86.75V23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 11.5H75.25V17.25H81V11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 92H29.25V63.25H0.5V92ZM6.25 69H23.5V86.25H6.25V69Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 74.75H12V80.5H17.75V74.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 0H46.5V5.75H58V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 23H52.25V17.25H58V11.5H40.75V5.75H35V11.5V14.375V17.25H46.5V23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 23H35V28.75H40.75V23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 28.75H52.25V34.5H35V40.25H58V28.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 51.75H12V46H6.25V34.5H0.5V57.5H6.25V51.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 34.5H12V40.25H17.75V34.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 57.5H46.5V51.75H40.75V46H29.25V34.5H23.5V46H17.75V57.5H23.5V51.75H26.375H29.25H35V57.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 46H52.25V57.5H58V46Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.25 63.25H35V69H46.5V86.25H35V92H52.25V86.25H63.75V80.5H52.25V63.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 74.75H35V80.5H40.75V74.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.75 63.25H58V74.75H63.75V63.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75 74.75H69.5V92H75.25V80.5H86.75V74.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5 86.25H81V92H92.5V86.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5 63.25H86.75V69H92.5V63.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 69H75.25V51.75H63.75V57.5H69.5V69Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 40.25H75.25V34.5H69.5V40.25H63.75V46H86.75V40.25H92.5V34.5H81V40.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5 51.75H81V57.5H92.5V51.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14164_107620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "currentColor",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/qr.b0ff3b26.svg";
export { ForwardRef as ReactComponent };